export default __webpack_public_path__ + "static/media/forward.141516db.svg";